module.exports = __webpack_public_path__ + "static/media/yes-icon.01a484ab.png";